"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightMenu = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var model_1 = require("../../../../model");
var errorPredicates_1 = require("../../../../_staging/errors/errorPredicates");
var dashboardContexts_1 = require("../../../dashboardContexts");
var insightMenu_1 = require("../../insightMenu");
exports.useInsightMenu = function (config) {
    var insight = config.insight, widget = config.widget;
    var _a = tslib_1.__read(react_1.useState(false), 2), isMenuOpen = _a[0], setIsMenuOpen = _a[1];
    var closeMenu = react_1.useCallback(function () { return setIsMenuOpen(false); }, []);
    var openMenu = react_1.useCallback(function () { return setIsMenuOpen(true); }, []);
    var insightMenuItemsProvider = dashboardContexts_1.useDashboardCustomizationsContext().insightMenuItemsProvider;
    var defaultMenuItems = useDefaultMenuItems(config, insightMenuItemsProvider, setIsMenuOpen);
    var menuItems = react_1.useMemo(function () {
        return insightMenuItemsProvider
            ? insightMenuItemsProvider(insight, widget, defaultMenuItems, closeMenu, "view")
            : defaultMenuItems;
    }, [insightMenuItemsProvider, insight, widget, defaultMenuItems, closeMenu]);
    return { menuItems: menuItems, isMenuOpen: isMenuOpen, openMenu: openMenu, closeMenu: closeMenu };
};
function useDefaultMenuItems(config, insightMenuItemsProvider, setIsMenuOpen) {
    var exportCSVEnabled = config.exportCSVEnabled, exportXLSXEnabled = config.exportXLSXEnabled, scheduleExportEnabled = config.scheduleExportEnabled, onExportCSV = config.onExportCSV, onExportXLSX = config.onExportXLSX, onScheduleExport = config.onScheduleExport, isScheduleExportVisible = config.isScheduleExportVisible, widget = config.widget;
    var intl = react_intl_1.useIntl();
    var execution = model_1.useDashboardSelector(model_1.selectExecutionResultByRef(widget.ref));
    return react_1.useMemo(function () {
        var defaultMenuItemsGetter = !insightMenuItemsProvider
            ? insightMenu_1.getDefaultLegacyInsightMenuItems
            : insightMenu_1.getDefaultInsightMenuItems;
        return defaultMenuItemsGetter(intl, {
            exportCSVDisabled: !exportCSVEnabled,
            exportXLSXDisabled: !exportXLSXEnabled,
            scheduleExportDisabled: !scheduleExportEnabled,
            onExportCSV: function () {
                setIsMenuOpen(false);
                onExportCSV();
            },
            onExportXLSX: function () {
                setIsMenuOpen(false);
                onExportXLSX();
            },
            onScheduleExport: function () {
                setIsMenuOpen(false);
                onScheduleExport();
            },
            isScheduleExportVisible: isScheduleExportVisible,
            isDataError: errorPredicates_1.isDataError(execution === null || execution === void 0 ? void 0 : execution.error),
        });
    }, [
        insightMenuItemsProvider,
        execution,
        exportCSVEnabled,
        exportXLSXEnabled,
        scheduleExportEnabled,
        onExportCSV,
        onExportXLSX,
        onScheduleExport,
        isScheduleExportVisible,
        intl,
        setIsMenuOpen,
    ]);
}
//# sourceMappingURL=useInsightMenu.js.map